import Heading from 'components/Heading'
import Icon from 'components/Icon'
import * as React from 'react'

import { Col } from 'components/Grid'

import classNames from 'classnames'
import './Steps.scss'

interface StepsProps {
  icon: JSX.Element
  iconViewBox?: string
  heading?: string | JSX.Element
  story?: string | JSX.Element
  hideNumber?: boolean
  keepIcon?: boolean
}

const Steps: React.FC<StepsProps> = props => {
  const className = classNames(
    'srprs-steps',
    props.hideNumber ? 'hide-number' : '',
    props.keepIcon ? 'keep-icon' : '',
  )
  return (
    <Col className={className}>
      <header>
        <Icon icon={props.icon} />
        {props.heading ? (
          <Heading level={3}>
            <>{props.heading}</>
          </Heading>
        ) : null}
      </header>
      <div className="content">
        <p>{props.story}</p>
      </div>
    </Col>
  )
}

export const StepsHome: React.FC<StepsProps> = props => {
  const className = classNames(
    'srprs-steps',
    'srprs-steps-home',
    props.hideNumber ? 'hide-number' : '',
    props.keepIcon ? 'keep-icon' : '',
  )
  return (
    <Col className={className}>
      <header>
        <Icon icon={props.icon} viewBox={props.iconViewBox} />
        {props.heading ? (
          <Heading alternate level={3}>
            <>{props.heading}</>
          </Heading>
        ) : null}
      </header>
      <div className="content">
        <p>{props.story}</p>
      </div>
    </Col>
  )
}

export default Steps
